export enum RegistrationStatus {
    DETAILS_COMPLETE = 2
};